module.exports = __webpack_public_path__ + "img/dic_local_point_g2.49f103db.gif";